<template>
  <div>
    <AddMetadataDialog
        :show="openAddMetadataDialog"
        :title="$tc('document.setMetadataSearchDialog.message', totalHits, { count: totalHits })"
        @cancel="openAddMetadataDialog=false"
        @done="openAddMetadataDialog=false"
    ></AddMetadataDialog>
    <v-menu left v-if="totalHits > 0 " id="documents_menu" ref="documents_menu" offset-y>
      <template v-slot:activator="{ on: menu }">
        <v-tooltip left>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
                style="height: 45px"
                slot="activator"
                small
                text
                id="tb_btn_actionsOnCurrentSearch"
                v-on="{ ...tooltip, ...menu }"
                :loading="datasetLoading"
            >
              <v-icon> mdi-menu</v-icon>
            </v-btn>
          </template>
          {{ $tc("app.tooltip.actionOnCurrentSearch", totalHits, {count: totalHits}) }}
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item
            v-if="canExportDocuments"
            id="btn_download_current_search"
            @click="downloadCurrentSearch()"
        >
          <v-icon class="mr-2">mdi-cloud-download</v-icon>
          <v-list-item-title>
            {{ $tc("app.tooltip.downloadCurrentSearch", totalHits, {count: totalHits}) }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item
            v-if="canDeleteDocuments"
            id="btn_delete_current_search"
            @click="openConfirmDeleteDocumentDialog = true"
        >
          <v-icon class="mr-2">mdi-delete</v-icon>
          <v-list-item-title>
            {{ $tc("app.tooltip.deleteCurrentSearch", totalHits, {count: totalHits}) }}<span><strong>...</strong></span>
          </v-list-item-title>
        </v-list-item>
        <DeleteConfirmDialog
            v-if="openConfirmDeleteDocumentDialog"
            idHint="document"
            :title="$t('document.deleteSearchDialog.title')"
            :html="$tc('document.deleteSearchDialog.message', totalHits, { count: totalHits })"
            withStrongConfirmation="true"
            @no="openConfirmDeleteDocumentDialog = false"
            @yes="deleteCurrentSearch()"
        ></DeleteConfirmDialog>

        <v-list-item
            v-if="canModifyMetadata && canSeeMetadata"
            id="btn_add-metadata"
            @click="openAddMetadataDialog = true"
        >
          <v-icon class="mr-2">mdi-note-plus</v-icon>
          <v-list-item-title>
            {{ $tc("app.tooltip.setMetadataOnCurrentSearch", totalHits, {count: totalHits}) }}<span><strong>...</strong></span>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
            v-if="isClassificationProject"
            id="btn_add-category"
            @click="openCategorySelector = true"
        >
          <v-icon class="mr-2">mdi-plus</v-icon>
          <v-list-item-title>
            {{ $tc("app.tooltip.addCategory", totalHits, {count: totalHits}) }}<span><strong>...</strong></span>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <AddCategoryDialog
        :show="openCategorySelector"
        :title="$tc('app.label.addCategoryOnSearchedDocument', totalHits, { count: totalHits })"
        @cancel="openCategorySelector=false"
        @done="openCategorySelector=false"
    ></AddCategoryDialog>
  </div>
</template>

<script>
import AddMetadataDialog from "./AddMetadataDialog";
import DeleteConfirmDialog from "../components/utils/DeleteConfirmDialog";
import AddCategoryDialog from "@/components/dialogs/AddCategoryDialog";
import {mapState, mapGetters, mapActions} from "vuex";

export default {
  components: {
    AddMetadataDialog,
    DeleteConfirmDialog,
    AddCategoryDialog,
  },
  data() {
    return {
      openCategorySelector: false,
      datasetLoading: false,
      openConfirmDeleteDocumentDialog: false,
      openAddMetadataDialog: false,
    };
  },
  computed: {
    ...mapState(["project"]),
    ...mapGetters(["isClassificationProject"]),
    ...mapGetters("auth", [
      "canExportDocuments",
      "canDeleteDocuments",
      "canModifyMetadata",
      "canSeeMetadata",
    ]),
    ...mapState("document", [
      "totalHits",
      "searchParams",
    ]),
  },
  methods: {
    ...mapActions("document", [
      "searchAndExportDocuments",
      "searchAndDeleteDocuments",
    ]),
    async downloadCurrentSearch() {
      this.datasetLoading = true;
      let data = await this.searchAndExportDocuments(this.searchParams);

      const contentType = "application/json";
      const dData = JSON.stringify(data, null, 2);
      const blob = new Blob([dData], {type: contentType});
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${this.project.name}-export-search.json`);
      document.body.appendChild(link);
      link.click();
      this.datasetLoading = false;
    },
    async deleteCurrentSearch() {
      this.openConfirmDeleteDocumentDialog = false;
      await this.searchAndDeleteDocuments(this.searchParams);
      this.$router.push({
        name: "documents",
      });
    },
  },
};
</script>
